<template>
  <div>
    <b-row class="py-1 d-flex">
      <b-col cols="10">
        <v-select
          v-model="user_id"
          :options="optionsAllUser"
          placeholder="User"
        />
      </b-col>
      <b-col cols="2">
        <b-button
          v-if="!addUserLoad"
          :disabled="!user_id"
          variant="primary"
          @click="addUser"
        >
          Add
        </b-button>
        <b-button
          v-if="addUserLoad"
          variant="primary"
          disabled
          class="d-flex align-items-center"
        >
          <b-spinner
            v-for="item in 3"
            :key="item"
            small
            type="grow"
          />
        </b-button>
      </b-col>

    </b-row>
    <b-table
      small
      :fields="fields"
      :items="dataTable"
      responsive="sm"
      :busy="dataLoad"
    >
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle" />
          <strong>Loading...</strong>
        </div>
      </template>
      <template #cell(remove)="data">
        <feather-icon
          v-if="removeUserLoad !== data.item.id"
          icon="TrashIcon"
          size="18"
          class="text-danger cursor-pointer"
          @click="removeUser(data.item.id)"
        />
        <b-spinner
          v-else
          small
          label="Spinning"
          class="text-danger"
        />
      </template>
    </b-table>
  </div>
</template>

<script>
import VSelect from 'vue-select'
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import decryptData from '@/store/auth/decryptData'

export default {
  components: {
    'v-select': VSelect,
  },
  props: {
    sourceData: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      fields: [
        { key: 'name', label: 'Full Name' },
        { key: 'email', label: 'Email' },
        { key: 'remove', label: 'Delete' },
      ],
      dataLoad: false,
      addUserLoad: false,
      removeUserLoad: null,
      dataTable: [],
      user_id: '',
    }
  },
  computed: {
    optionsAllUser() {
      const list = this.$store.getters['generalData/assignList/assignList'] || []

      return list.map(user => ({
        value: user.value.id, // ✅ what v-model gets
        label: user.label, // ✅ what user sees
      }))
    },
  },
  watch: {
    sourceData: {
      immediate: true, // run on component mount
      handler(newVal) {
        if (newVal) {
          this.getPermissionByName()
        }
      },
    },
  },
  async mounted() {
    if (!this.$store.getters['generalData/assignList/assignListLoaded']) {
      await this.$store.dispatch('generalData/assignList/fetchAssignList')
    }
  },

  methods: {
    async getPermissionByName() {
      try {
        this.dataLoad = true

        const response = await axios.get(`/permissions/${this.sourceData}`)
        const data = decryptData(response.data.payload)?.data?.permission?.users
        this.dataTable = data
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            icon: 'BellIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.dataLoad = false
      }
    },
    addUser() {
      this.addUserLoad = true
      axios
        .post(`/permissions/user/${this.user_id.value}/assign`,
          { permission: this.sourceData })
        .then(() => {
          this.getPermissionByName()
          this.user_id = ''
        })
        .finally(() => {
          this.addUserLoad = false
        })
    },
    removeUser(id) {
      this.removeUserLoad = id
      axios.delete(`/permissions/user/${id}/revoke`, {
        data: {
          permission: this.sourceData,
        },
      })
        .then(() => {
          this.getPermissionByName()
        })
        .finally(() => {
          this.removeUserLoad = null
        })
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
